import madayn from "../../../images/madayn.svg";
import download from '../../../images/book-download.svg'
import priority from '../../../images/priority.svg'
import toDo from '../../../images/toDo.svg'
import service from '../../../images/service.svg'
import campaign from '../../../images/campaign.svg'

export interface SectionItem {
    img: any;
    alt: string;
    title: string;
    text: string;
    download?: {
        url: string;
        fileName: string;
    }
}

export interface Sections {
    [key: number]: SectionItem[];
}

export const sections: Sections = {
    1: [
        {
            img: madayn,
            alt: "about.content.madayn.alt",
            title: "about.content.madayn.title",
            text: "about.content.madayn.text"
        },
        {
            img: download,
            alt: "about.content.exploreOpportunities.alt",
            title: "about.content.exploreOpportunities.title",
            text: "about.content.exploreOpportunities.text",
            download: {
                url: '/investors-guide2022.pdf',
                fileName: 'investors-guide2022.pdf'
            }
        }
    ],
    2: [
        {
            img: priority,
            alt: "about.content.priorityAndCommunications.alt",
            title: "about.content.priorityAndCommunications.title",
            text: "about.content.priorityAndCommunications.text"
        },
        {
            img: toDo,
            alt: "about.content.easyToDo.alt",
            title: "about.content.easyToDo.title",
            text: "about.content.easyToDo.text"
        }
    ],
    3: [
        {
            img: service,
            alt: "about.content.serviceProvider.alt",
            title: "about.content.serviceProvider.title",
            text: "about.content.serviceProvider.text"
        },
        {
            img: campaign,
            alt: "about.content.campaignMembership.alt",
            title: "about.content.campaignMembership.title",
            text: "about.content.campaignMembership.text"
        }
    ]
};
